module.exports = __webpack_public_path__ + "static/media/icon-loader.f6f63208.gif";